/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import map from 'lodash/map';
import get from 'lodash/get';
import isField from './isField';

const styles = {
    validations: {
        border: '1px solid red',
        borderRadius: '5px',
        backgroundColor: 'rgba(255,0,0,0.1)',
        width: 'calc(100% - 2rem)',
        minHeight: '100px',
        display: 'flex',
        margin: '1rem',
        marginTop: '50px',
    },
    message: {
        color: 'red',
    },
};

@isField
class Validations extends React.Component {
    render() {
        const { validations } = this.props;
        const details = get(validations, 'error.details', false);

        if (!details) return null;

        return (
            <div style={styles.validations}>
                <ul>
                    {map(validations.error.details, (error, index) => (
                        <li style={styles.message} key={index}>
                            {error.message}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default Validations;
